import React, { useState } from 'react';
import * as styles from './ToggleButton.module.scss';
import { SmallSpinner } from '@components/Spinner';
import classNames from 'classnames';

export default React.memo(function ToggleButton({
  isActive,
  isLoading,
  isDisabled,
  onChange,
  className,
  text,
  children,
  spinnerSize,
  spinnerThickness = 6.6,
  loadingText,
  ...restProps
}) {
  const [disableHoverEffect, setDisableHoverEffect] = useState(false);
  const content = text ?? children;

  return (
    <button
      aria-pressed={isActive}
      className={classNames(styles.button, className, {
        [styles.active]: isActive,
        'toggle-loading': isLoading && isActive,
        [styles.loading]: isLoading && isActive,
        [styles.disabled]: isDisabled,
        [styles.disableHover]: disableHoverEffect,
        [styles.hasLoadingText]: !!loadingText
      })}
      onClick={() => {
        setDisableHoverEffect(true);
        onChange?.(!isActive);
      }}
      onMouseLeave={() => setDisableHoverEffect(false)}
      {...restProps}
    >
      <span className={classNames('toggle-button-icon', styles.icon)}>
        <span className={styles.spinner}>
          <SmallSpinner
            size={spinnerSize}
            thickness={spinnerThickness}
          />
        </span>
      </span>
      {content && (
        <span className={styles.label}>
          <span className={styles.text}>{content}</span>
          {loadingText && (
            <span className={styles.loadingText}>{loadingText}</span>
          )}
        </span>
      )}
    </button>
  );
});
